export var mailboxesRelativePath = "/mailboxes";
export var createMailboxesApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(mailboxesRelativePath);
    return {
        getMailboxes: function () { return http.get(apiUrl); },
        addMailbox: function (dto) {
            return http.post(apiUrl, dto);
        },
        updateMailbox: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.id), { forwardingAddress: dto.forwardingAddress });
        },
        deleteMailbox: function (dto) { return http.delete("".concat(apiUrl, "/").concat(dto.id)); },
        setDefaultMailbox: function (dto) { return http.put("".concat(apiUrl, "/").concat(dto.id, "/setDefault"), {}); }
    };
};
//# sourceMappingURL=index.js.map